import { RGB } from '../models';

export function rgbToHex([r, g, b]: RGB | Readonly<RGB>): string {
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

function toHex(value: number): string {
  const hex = value.toString(16).toUpperCase();

  return hex.length === 1 ? `0${hex}` : hex;
}
